<template>
  <a-modal
    class="modal-content"
    :title="title"
    :width="600"
    :visible="visible"
    ok-text="保存"
    @ok="handleOk"
    @cancel="hideModal"
  >
    <div style="margin-bottom: 10px; color: #fa9600">
      *可根据系统提供的模版进行填写后在上传，也可直接进行第二步
    </div>
    <div class="flex-align-center" style="margin-bottom: 10px">
      <span class="title-2">第一步：下载模版</span>
      <a style="margin-left: 10px" :href="tabList[0].fileUrl">下载{{ tabList[0].fileName }}</a>
    </div>
    <!--        accept=".xls,.xlsx"-->
    <a-upload-dragger
      :disabled="false"
      name="file"
      :file-list="fileList"
      :action="importExcelUrl"
      :headers="tokenHeader"
      @change="handleChange"
    >
      <p class="ant-upload-drag-icon">
        <a-icon type="inbox" />
      </p>
      <p class="ant-upload-text">添加文件</p>
      <!--          <p class="ant-upload-hint">(仅支持.xls或.xlsx格式的文件)</p>-->
    </a-upload-dragger>
    <div class="title-2" style="margin: 10px 0">第二步：关爱记录</div>
    <a-form-model
      ref="ruleForm"
      :labelCol="{ span: 4 }"
      :wrapperCol="{ span: 20 }"
      :model="form"
      :rules="rules"
    >
      <!--      <a-form-model-item label="关爱时间">-->
      <!--        <a-date-picker v-model="form.date" placeholder="请选择关爱时间" style="width: 100%" />-->
      <!--      </a-form-model-item>-->
      <a-form-model-item label="问题原因">
        <j-dict-select-tag
          v-model="form.tagId"
          placeholder="请选择问题原因"
          dictCode="emotional_type"
        />
      </a-form-model-item>
      <a-form-model-item label="干预措施">
        <j-dict-select-tag
          v-model="form.interventionId"
          placeholder="请选择干预措施"
          dictCode="intervention"
        />
      </a-form-model-item>
      <a-form-model-item label="效果反馈">
        <j-dict-select-tag
          v-model="form.effectFeedback"
          placeholder="请选择效果反馈"
          dictCode="effect_feedback"
        />
      </a-form-model-item>
      <a-form-model-item label="具体情况说明">
        <a-textarea
          v-model="form.comment"
          :auto-size="{ minRows: 5, maxRows: 8 }"
          placeholder="请输入具体情况说明"
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { postAction } from '@/api/manage'
import { getStoreFileUrl } from '@/utils/util'

export default {
  name: 'AddCareRecord',
  mixins: [JeecgListMixin],
  props: {
    title: {
      type: String,
      default: '关爱记录',
    },
  },
  data() {
    return {
      visible: false,
      form: {},
      rules: {
        // name: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        // dateRang: [{ required: true, message: '请选择日期范围', trigger: 'blur' }],
        // radius: [{ required: true, message: '请选择测评范围', trigger: 'blur' }],
        // evalWay: [{ required: true, message: '请选择测评方式', trigger: 'blur' }],
      },
      currEvalInfo: {},
      // uploadAction: window._CONFIG['domianURL'] + '/sys/common/upload?biz=studentTag',
      importExcelUrl: window._CONFIG['domianURL'] + '/sys/common/upload?biz=emotionComments',
      fileList: [],
      activeKey: '10',
      isShowDetails: false,
      tabList: [
        {
          tab: '班主任沟通',
          key: '6',
          fileName: '班主任沟通记录表',
          fileUrl: getStoreFileUrl('/schoolEvaluation/班主任沟通记录表.docx'),
        },
      ],
    }
  },
  methods: {
    showModal(data, index) {
      this.currEvalInfo = data
      console.log('数据：', data)
      this.visible = true
      this.fileList = []
    },
    hideModal() {
      this.visible = false
      this.form = {}
      this.fileList = []
    },
    async handleOk() {
      const params = {
        studentId: this.currEvalInfo.studentId,
        dataType: this.activeKey,
        file: this.fileList?.[this.fileList.length - 1]?.url || '',
        ...this.form,
      }
      const res = await postAction('aigoes/emotionComments/add', params)
      if (res.success) {
        this.$message.success(res.message)
        this.$emit('refreshData')
      } else {
        this.$message.error(res.message || '保存失败')
      }
      console.log('提交结果：', res)
      this.hideModal()
    },
    handleChange(info) {
      let fileList = [...info.fileList]
      fileList = fileList.map((file) => {
        if (file.response) {
          file.url = file.response.message
        }
        return file
      })
      this.fileList = fileList
      console.log('fileList', fileList)
    },
    changeTab(key) {
      this.activeKey = key
    },
  },
}
</script>
<style scoped lang="less">
.modal-content {
  /deep/ .ant-modal-header {
    border-bottom: none;
  }
  /deep/ .ant-modal-body {
    padding: 0 24px 10px;
  }
  /deep/ .ant-upload {
    height: 149px;
  }
}
</style>
